'use client';

import { useEffect } from 'react';
import './PwaRuntime.module.scss';

import { registerChattengerServiceWorker } from '@/features/pwa/serviceWorkerRegistration';
import { getWindowOrNull } from '@/lib/browser/runtime';

export const PwaRuntime = () => {
    useEffect(() => {
        const browserWindow = getWindowOrNull();
        if (!browserWindow) {
            return;
        }

        let isCancelled = false;
        let idleHandle: number | null = null;
        let timeoutHandle: number | null = null;

        const register = () => {
            void registerChattengerServiceWorker().catch(() => {
                // PWA registration must never block the app shell.
            });
        };

        if (typeof browserWindow.requestIdleCallback === 'function') {
            idleHandle = browserWindow.requestIdleCallback(() => {
                if (!isCancelled) {
                    register();
                }
            });
        } else {
            timeoutHandle = browserWindow.setTimeout(() => {
                if (!isCancelled) {
                    register();
                }
            }, 250);
        }

        return () => {
            isCancelled = true;

            if (idleHandle !== null && typeof browserWindow.cancelIdleCallback === 'function') {
                browserWindow.cancelIdleCallback(idleHandle);
            }

            if (timeoutHandle !== null) {
                browserWindow.clearTimeout(timeoutHandle);
            }
        };
    }, []);

    return null;
};
